import { Notification } from "element-ui";
import { api } from "../../gateways/unilabCiprianiApi";

export default {
  getMaintenanceStatus() {
    return new Promise((resolve, reject) => {
      api
        .get("general/getMaintenanceStatus")
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          // title: "Attenzione",
          //  message: response.data.errorMessage
          //});
          reject(error);
        });
    });
  },
  getApps() {
    return new Promise((resolve, reject) => {
      api
        .get("general/apps")
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  getMenuItems() {
    return new Promise((resolve, reject) => {
      api
        .get("general/menu")
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  //local corrisponde all'indirizzo del localhost
  getFavicon(local) {
    return new Promise((resolve, reject) => {
      api
        .get("general/favicon?local=" + local)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: response.data.errorMessage
          //});
          reject(error);
        });
    });
  },
  getTitle(local) {
    return new Promise((resolve, reject) => {
      api
        .get("general/changeTitle?local=" + local)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: response.data.errorMessage
          //});
          reject(error);
        });
    });
  },
  newOffer() {
    return new Promise((resolve, reject) => {
      api
        .post("gestione-offerte/nuovaofferta")
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  getEULAText() {
    return new Promise((resolve, reject) => {
      api
        .get("general/geteulatext")
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  getBannerInfo(){
    return new Promise((resolve, reject) => {
      api
        .get("general/bannerInfo")
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: error.data.errorMessage
          //});
          reject(error);
        });
    });
  },
  getFluidsDividedByTipo(){
    return new Promise((resolve, reject) => {
      api
        .get("general/fluidListDividedByCategory")
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: error.data.errorMessage
          //});
          reject(error);
        });
    });
  },
  getFluids(idCodiceTipo) {
    return new Promise((resolve, reject) => {
      api
        .get("general/fluidlist?idCodiceTipo=" + idCodiceTipo)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: error.data.errorMessage
          //});
          reject(error);
        });
    });
  },
  getFluidsMgt(idCodiceTipo) {
    return new Promise((resolve, reject) => {
      api
        .get("general/fluidlistmgt?idCodiceTipo=" + idCodiceTipo)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: error.data.errorMessage
          //});
          reject(error);
        });
    });
  },
  getFluidGroup(nomefile) {
    return new Promise((resolve, reject) => {
      api
        .get("general/getfluidgroup?nomefile=" + nomefile)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: error.data.errorMessage
          //});
          reject(error);
        });
    });
  },
  canShowFluidManagement() {
    return new Promise((resolve, reject) => {
      api
        .get("general/canshowfluidmanagement")
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: error.data.errorMessage
          //});
          reject(error);
        });
    });
  },
  updateFluidGroup(fluid) {
    return new Promise((resolve, reject) => {
      api
        .post("general/updatefluidgroup", fluid)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  getLogoVisibility() {
    return new Promise((resolve, reject) => {
      api
        .get("general/logoVisible")
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  getPathLogoBrandActiveCustomerProfile(local) {
    return new Promise((resolve, reject) => {
      api
        .get("general/getPathLogoBrandActiveCustomerProfile?local=" + local)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  getCheckedCompliances() {
    return new Promise((resolve, reject) => {
      api
        .get("general/getCheckCompliances")
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          //Notification.error({
          //  title: "Attenzione",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  setCheckedCompliances(compliance) {
    return new Promise((resolve, reject) => {
      api
        .post("general/setCheckCompliances", compliance)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  setDatiUtente(datiUtente) {
    return new Promise((resolve, reject) => {
      api
        .post("general/setDatiUtente", datiUtente)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  }
};
